import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline, StyledEngineProvider } from '@mui/material';

// routing
import Routes from 'routes';

// defaultTheme
import themes from 'themes';

// project imports
import NavigationScroll from 'layout/NavigationScroll';
import ErrorBoundary from 'ui-component/ErrorBoundary';
import { MENU_OPEN } from 'store/action-types';

// maps a route prefix to the menu item that should be highlighted
const ids = {
  '/tenants': 'tenants',
  '/instances': 'instances',
  '/parks': 'parks',
  '/clients': 'clients',
  '/orders/sent': 'sent_orders',
  '/orders/traded-volumes': 'traded_volumes',
  '/orders/open-positions': 'open_positions',
  '/orders/audit-events': 'audit_events'
};

// Sections whose views live one level deeper (/orders/sent) need the two-segment
// prefix; everything else is identified by its first segment.
const menuIdForPath = (pathname) => {
  const [, first, second] = pathname.split('/');
  return ids[`/${first}/${second}`] ?? ids[`/${first}`];
};

// ==============================|| APP ||============================== //

const App = () => {
  const customization = useSelector((state) => state.customization);
  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch({ type: MENU_OPEN, id: menuIdForPath(location.pathname) });
  }, [dispatch, location.pathname]);

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={themes(customization)}>
        <CssBaseline />
        <NavigationScroll>
          <ErrorBoundary>
            <Routes />
          </ErrorBoundary>
        </NavigationScroll>
      </ThemeProvider>
    </StyledEngineProvider>
  );
};

export default App;
